import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useFocusMainContent = () => {
  const { pathname } = useLocation();

  const focusMain = useCallback(() => {
    document.getElementById('main-content')?.focus();
  }, []);

  useEffect(() => {
    focusMain();
  }, [pathname, focusMain]);

  return { focusMain };
};

export default useFocusMainContent;
